import {
  Button,
  DialogActions,
} from '@mui/material';

import { Flex } from '@synthetica-ai/components';
import { withProps } from '@synthetica-ai/system';
import { finalizeDrydock } from 'models/drydock';

const Finalize = ({
  props,
  closeDialog,
  finalizeDrydock,
}) => (
  <Flex center direction="column" style={{ width: '100%' }}>
    <DialogActions sx={{ ml: 'auto', mt: '1rem' }}>
      <Button
        color="primary"
        variant="outlined"
        onClick={closeDialog}
      >
        Cancel
      </Button>

      <Button
        color="primary"
        variant="contained"
        onClick={() => finalizeDrydock()}
      >
        Confirm
      </Button>
    </DialogActions>
  </Flex>
);

export default withProps({
  finalizeDrydock,
})(Finalize);
